import { AuthService } from '@app/services';
import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';
import { Role } from '@models/account/role.model';
import { Office } from '@models/company/office.model';

export const DefaultRequiredColumnsTypes: ColumnType[] = [
    {
        label: 'Legal First Name',
        relatedLabels: ['Given Name', 'First Name'],
        translatableLabel: 'import.columnTypes.legalFirstName',
        serializeName: 'account.legalFirstName',
        input: InputType.string,
        required: true,
    },
    {
        label: 'Legal Last Name',
        relatedLabels: ['Surname', 'Maiden Name', 'Last Name'],
        translatableLabel: 'import.columnTypes.legalLastName',
        serializeName: 'account.legalLastName',
        input: InputType.string,
        required: true,
    },
    {
        label: 'Email',
        translatableLabel: 'import.columnTypes.email',
        serializeName: 'account.email',
        input: InputType.email,
        required: true,
    },
    {
        label: 'Start Date',
        relatedLabels: ['Job Hired Date', 'Hired Date', 'Hired At'],
        translatableLabel: 'import.columnTypes.startDate',
        serializeName: 'hiredAt',
        input: InputType.date,
        required: true,
    },
    {
        label: 'Department',
        serializeName: 'departmentName',
        translatableLabel: 'import.columnTypes.department',
        input: InputType.string,
        required: true,
    },
    {
        label: 'Position',
        relatedLabels: ['Job', 'Job Title', 'Title'],
        translatableLabel: 'import.columnTypes.position',
        serializeName: 'jobTitle',
        input: InputType.string,
        required: true,
    },
    {
        label: 'Office Name',
        relatedLabels: ['Office', 'Office Location'],
        translatableLabel: 'import.columnTypes.officeName',
        serializeName: 'officeId',
        input: InputType.options,
        required: true,
        getOptions: function (auth: AuthService): Promise<any> {
            return Office.param('company', auth.company.id)
                .all()
                .then(([offices]) => {
                    this.options = offices.map((office) => ({
                        label: office.name,
                        value: office.id,
                    }));
                });
        },
    },
    {
        label: 'Employment Type',
        translatableLabel: 'import.columnTypes.employmentType',
        serializeName: 'employmentType',
        input: InputType.options,
        options: [
            {
                label: 'Full Time',
                relatedLabels: ['FT', 'Full-Time', 'FullTime', 'Full'],
                translatableLabel: 'import.optionTypes.fullTime',
                value: 'full-time',
            },
            {
                label: 'Part Time',
                relatedLabels: ['PT', 'Part-Time', 'PartTime', 'Part'],
                translatableLabel: 'import.optionTypes.partTime',
                value: 'part-time',
            },
            {
                label: 'Contractor',
                relatedLabels: ['Contract'],
                translatableLabel: 'import.optionTypes.contractor',
                value: 'contractor',
            },
            {
                label: 'Intern',
                relatedLabels: ['Internship'],
                translatableLabel: 'import.optionTypes.intern',
                value: 'intern',
            },
            { label: 'Volunteer', translatableLabel: 'import.optionTypes.volunteer', value: 'volunteer' },
            { label: 'Seasonal', translatableLabel: 'import.optionTypes.seasonal', value: 'seasonal' },
            { label: 'Consultant', translatableLabel: 'import.optionTypes.consultant', value: 'consultant' },
            { label: 'Other', translatableLabel: 'import.optionTypes.other', value: 'other' },
            { label: 'Casual', translatableLabel: 'import.optionTypes.casual', value: 'casual' },
        ],
        required: true,
    },
    {
        label: 'Humi Role Permission',
        relatedLabels: ['Role', 'Role Name'],
        translatableLabel: 'import.columnTypes.rolePermissions',
        serializeName: 'account.roleId',
        input: InputType.options,
        required: true,
        getOptions: function (auth: AuthService): Promise<any> {
            return Role.where('companyId', auth.company.id)
                .all()
                .then(([roles]) => {
                    this.options = roles.map((role) => ({
                        label: role.name,
                        value: role.id,
                    }));
                });
        },
    },
];
